import * as types from '@/constants/mutationTypes'

const state = {
  tagList: []
}
const getters = {
  tagList: state => state.tagList
}
const actions = {
  setTagList ({commit}, data) {
    commit(types.SET_TAG_LIST, {data})
  }
}
const mutations = {
  [types.SET_TAG_LIST] (state, {data}) {
    state.tagList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Tags/modules/store.js